import {t} from '../../getTranslations';

const MINUTES_OF_A_DAY = 60 * 24;
const MINUTES_OF_AN_HOUR = 60;

/**
 * XXX: packages/pageweb/src/common/util/date.ts 내의 getPeriodText 와 중복
 */
export function getPeriodText(minutes: number) {
  const returnTexts: string[] = [];
  let remainMinutes = minutes;
  if (remainMinutes >= MINUTES_OF_A_DAY) {
    const days = Math.floor(remainMinutes / MINUTES_OF_A_DAY);
    returnTexts.push(t('common_period_day', {values: {value: days}}));
    remainMinutes -= days * MINUTES_OF_A_DAY;
  }
  if (remainMinutes >= MINUTES_OF_AN_HOUR) {
    const hours = Math.floor(remainMinutes / MINUTES_OF_AN_HOUR);
    returnTexts.push(t('common_period_hour', {values: {value: hours}}));
    remainMinutes -= hours * MINUTES_OF_AN_HOUR;
  }
  if (remainMinutes > 0) {
    returnTexts.push(
      t('common_period_minute', {values: {value: remainMinutes}})
    );
  }
  return returnTexts.join(' ');
}
